<template>
  <div class="employee-cost">
    <xin-alert :xin-message="$xinI18n('大病医疗扣除需次年纳税人自行扣除，系统暂不支持按月扣除计算','home-dbylkcxcnnsrzxkcxtzbzcayk')"></xin-alert>
    <el-form :model="employeeCostForm"
             label-position="top"
             :rules="rules"
             size="small"
             ref="employeeCostForm">
      <el-form-item :label="$xinI18n('选择地区','EmployeeSet-AreaPicker-xuanzediqu')">
        <el-cascader
          v-model="employeeCostForm.areaArr"
          :options="cityTree"
          @change="handleChange"></el-cascader>
      </el-form-item>
      <el-form-item :label="$xinI18n('期望税后工资','home-qiwangshuihougongzi')" prop="realPay" :rules="salaryFieldValidate" v-if="isBeforeTax">
        <el-input v-model="employeeCostForm.realPay"></el-input>
      </el-form-item>
      <el-form-item :label="$xinI18n('税前基本工资','home-shuiqianjibengongzi')" prop="basePay" :rules="salaryFieldValidate" v-else>
        <el-input v-model="employeeCostForm.basePay" @input="changeSocialInsuranceBaseValue"></el-input>
      </el-form-item>
      <el-form-item :label="$xinI18n('是否缴纳社保','home-shifoujiaonashebao')">
        <el-select v-model="employeeCostForm.isSocialInsurance">
          <el-option :label="$xinI18n('缴纳','insurance-jiaona')" :value="1"></el-option>
          <el-option :label="$xinI18n('不缴纳','insurance-bujiaona')" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="employeeCostForm.isSocialInsurance == 1">
        <span slot="label">
          {{ $xinI18n('社保缴纳基数','home-shebaojiaonajishu') }}
          <el-tooltip effect="dark" :content="$xinI18n('基数范围为{#1}到{#2}','home-jishufanweiweidao',[insuranceBaseMin, insuranceBaseMax])" placement="right">
            <xin-icon xin-type="question"></xin-icon>
          </el-tooltip>
        </span>
        <el-select v-model="employeeCostForm.socialInsuranceType" @change="changeInsuranceValue">
          <el-option v-for="item in socialInsuranceOption" :label="item.label" :value="item.value"
                     v-bind:key="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$xinI18n('社保基数','insurance-shebaojishu')"
                    v-if="employeeCostForm.isSocialInsurance == 1"
                    prop="socialInsuranceBaseValue">
        <el-input v-model="employeeCostForm.socialInsuranceBaseValue"
                  :disabled="employeeCostForm.socialInsuranceType != 2"
                  :placeholder="$xinI18n('请输入社保基数','home-qingshurushebaojishu')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$xinI18n('是否缴纳公积金','home-sfjngjj')">
        <el-select v-model="employeeCostForm.isHouseFund">
          <el-option :label="$xinI18n('缴纳','insurance-jiaona')" :value="1"></el-option>
          <el-option :label="$xinI18n('不缴纳','insurance-bujiaona')" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$xinI18n('公积金缴纳基数','home-gongjijinjiaonajishu')" v-if="employeeCostForm.isHouseFund == 1">
        <el-select class="qj-select" v-model="employeeCostForm.houseFundType" @change="changeHouseFundBaseValue">
          <el-option v-for="item in socialInsuranceOption" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="employeeCostForm.isHouseFund == 1" prop="houseFundBaseValue">
        <span slot="label">
          {{ $xinI18n('公积金基数','insurance-gongjijinjishu') }}
          <el-tooltip effect="dark" :content="$xinI18n('基数范围为{#1}到{#2}','home-jishufanweiweidao',[houseFundMin, houseFundMax])" placement="right">
            <xin-icon xin-type="question"></xin-icon>
          </el-tooltip>
        </span>
        <el-input v-model="employeeCostForm.houseFundBaseValue"
                  :disabled="employeeCostForm.houseFundType!=2"
                  :placeholder="$xinI18n('请输入公积金基数','home-qsrgjjjs')">
        </el-input>
      </el-form-item>
      <el-form-item v-if="employeeCostForm.isHouseFund == 1"
                    prop="houseFundCompanyPercent">
        <span slot="label">
          {{ $xinI18n('缴纳比例','home-jiaonabili') }}
          <el-tooltip effect="dark" :content="$xinI18n('比例范围为{#1}到{#2}','home-bilifanweiweidao',[houseFundCompanyPercentMin, houseFundCompanyPercentMax])"
                      placement="right">
            <xin-icon xin-type="question"></xin-icon>
          </el-tooltip>
        </span>
        <el-input v-model="employeeCostForm.houseFundCompanyPercent" :placeholder="$xinI18n('数字范围在{#1}~{#2}之间','Common-validate-shuzifanweix-x',[0, 100])"></el-input>
      </el-form-item>
      <el-form-item :label="$xinI18n('是否包含专项扣除','home-sfbhzxkc')">
        <el-select v-model="employeeCostForm.isSpecialDeductions">
          <el-option :label="$xinI18n('包含','home-baohan')" :value="1"></el-option>
          <el-option :label="$xinI18n('不包含','set-bubaohan')" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$xinI18n('子女教育扣除','home-zinüjiaoyukouchu')" v-if="employeeCostForm.isSpecialDeductions == 1">
        <el-select v-model="employeeCostForm.childrenEducationDeduction" :placeholder="$xinI18n('请选择','Common-qingxuanze')">
          <el-option v-for="item in childrenEducationDeductionOption"
                     :label="item.text" :value="item.value"
                     :key="item.text">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="employeeCostForm.isSpecialDeductions == 1">
        <span slot="label">
          {{ $xinI18n('继续教育扣除','home-jixujiaoyukouchu') }}
          <el-tooltip effect="dark" :content="$xinI18n('职业资格继续教育等暂不支持分月定额扣除','home-zyzgjxjydzbzcfydekc')" placement="right">
            <xin-icon xin-type="question"></xin-icon>
          </el-tooltip>
        </span>
        <el-select v-model="employeeCostForm.continuingEducationDeduction" :placeholder="$xinI18n('请选择','Common-qingxuanze')">
          <el-option v-for="item in continuingEducationDeductionOption"
                     :label="item.text" :value="item.value"
                     :key="item.text">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$xinI18n('赡养老人扣除','home-shanyanglaorenkouchu')" v-if="employeeCostForm.isSpecialDeductions == 1">
        <el-select v-model="supportElderlyDeductionType">
          <el-option v-for="item in supportElderlyDeductionTypeOption"
                     :label="item.text" :value="item.value"
                     :key="item.text">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$xinI18n('赡养老人扣除数额','home-sylrkcse')"
                    v-if="employeeCostForm.isSpecialDeductions == 1 && supportElderlyDeductionType == 0">
        <el-select v-model="employeeCostForm.supportElderlyDeduction" :placeholder="$xinI18n('请选择','Common-qingxuanze')">
          <el-option v-for="item in supportElderlyDeductionOption"
                     :label="item.text" :value="item.value"
                     :key="item.text">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$xinI18n('赡养老人扣除数额','home-sylrkcse')"
                    v-if="employeeCostForm.isSpecialDeductions == 1 && supportElderlyDeductionType == 1"
                    prop="supportElderlyDeduction">
        <el-input type="number" v-model="employeeCostForm.supportElderlyDeduction"></el-input>
      </el-form-item>
      <el-form-item v-if="employeeCostForm.isSpecialDeductions == 1">
        <span slot="label">
          {{ $xinI18n('住房贷款扣除','home-zhufangdaikuankouchu') }}
          <el-tooltip effect="dark" :content="$xinI18n('住房贷款利息扣除与住房租金扣除同时只能享受一项','home-zfdklxkcyzfzjkctsznxsyx')" placement="right">
            <xin-icon xin-type="question"></xin-icon>
          </el-tooltip>
        </span>
        <el-select v-model="employeeCostForm.housingLoanDeduction" :placeholder="$xinI18n('请选择','Common-qingxuanze')"
                   @change="switchOnly('housingRent')">
          <el-option v-for="item in housingLoanDeductionOption"
                     :label="item.text" :value="item.value"
                     :key="item.text">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$xinI18n('住房租金扣除','home-zhufangzujinkouchu')" v-if="employeeCostForm.isSpecialDeductions == 1">
        <el-select class="qj-select" v-model="employeeCostForm.housingRentDeduction" :placeholder="$xinI18n('请选择','Common-qingxuanze')"
                   @change="switchOnly('housingLoan')">
          <el-option v-for="item in housingRentDeductionOption"
                     :label="item.text" :value="item.value"
                     :key="item.text">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$xinI18n('3岁以下婴幼儿照护','home-syxyyezh')">
        <el-select class="qj-select" v-model="employeeCostForm.childReduceDeduction" :placeholder="$xinI18n('请选择','Common-qingxuanze')">
          <el-option v-for="item in childReduceDeductionOption"
                     :label="item.text" :value="item.value"
                     :key="item.text">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="个人养老金" prop="privatePensionDeduction" :rules="pensionFieldValidate">
        <el-input type="number" v-model="employeeCostForm.privatePensionDeduction" placeholder="请输入扣除金额"></el-input>
      </el-form-item>
    </el-form>
    <div class="count-result" v-if="showResult">
      <div class="count-result-title">
        <h4>{{ $xinI18n('计算结果','home-jisuanjieguo') }}</h4>
        <span>（{{ $xinI18n('由于各地工伤保险略有差异, 计算结果仅供参考','home-yygdgsbxlycyjsjgjgck') }}）</span>
      </div>
      <template v-if="!isBeforeTax">
        <table>
          <tbody>
          <tr>
            <td>{{ $xinI18n('个人税前收入','home-gerenshuiqianshouru') }}</td>
            <td class="count-value">{{resultForm.basePayBeforeTax}}</td>
            <td>{{ $xinI18n('个人缴纳公积金','home-gerenjiaonagongjijin') }}</td>
            <td class="count-value">{{resultForm.personalHouseFund}}</td>
          </tr>
          <tr>
            <td>{{ $xinI18n('公司缴纳公积金','home-gsjngjj') }}</td>
            <td class="count-value">{{resultForm.companyHouseFund}}</td>
            <td>{{ $xinI18n('个人缴纳社保','home-gerenjiaonashebao') }}</td>
            <td class="count-value">{{resultForm.personalInsurance}}</td>
          </tr>
          <tr>
            <td>{{ $xinI18n('公司缴纳社保','home-gongsijiaonashebao') }}</td>
            <td class="count-value">{{resultForm.companyInsurance}}</td>
            <td>{{ $xinI18n('公司花费雇用成本','home-gshfgycb') }}</td>
            <td class="count-value">{{resultForm.companyTotalCost}}</td>
          </tr>
          <tr>
            <td>{{ $xinI18n('专项扣除免税总额','home-zxkcmsze') }}</td>
            <td class="count-value">{{resultForm.personalTaxExemption}}</td>
            <td></td>
            <td></td>
          </tr>
          <template v-for="i in 12">
            <tr v-if="resultForm.basePayAfterTaxWithMonth && resultForm.withholdableAdvancePayment">
              <td>{{$xinI18n('第{#1}个月个人税后收入','home-dgygrshsr',[i])}}</td>
              <td class="count-value">{{resultForm.basePayAfterTaxWithMonth[i]}}</td>
              <td>{{$xinI18n('第{#1}个月应扣预缴额','home-dgyykyje',[i])}}</td>
              <td class="count-value">{{resultForm.withholdableAdvancePayment[i]}}</td>
            </tr>
          </template>
          <tr>
            <td>{{ $xinI18n('个人税后总和','home-gerenshuihouzonghe') }}</td>
            <td class="count-value">{{resultForm.accumulatedBasePayAfterTax}}</td>
            <td>{{ $xinI18n('应预扣缴额总和','home-yingyukoujiaoezonghe') }}</td>
            <td class="count-value">{{resultForm.accumulatedAnnualTaxes}}</td>
          </tr>
          </tbody>
        </table>
      </template>
      <template v-else>
        <table>
          <tbody>
          <tr>
            <td>{{ $xinI18n('个人税前年收入','home-grsqnsr') }}</td>
            <td class="count-value">{{resultForm.basePayBeforeTaxWithYear}}</td>
            <td>{{ $xinI18n('个人税后年收入','home-grshnsr') }}</td>
            <td class="count-value">{{resultForm.basePayAfterTaxWithYear}}</td>
          </tr>
          <tr>
            <td>{{ $xinI18n('个人税前收入','home-gerenshuiqianshouru') }}</td>
            <td class="count-value">{{resultForm.basePayBeforeTax}}</td>
            <td>{{ $xinI18n('个人税后平均收入','home-grshpjsr') }}</td>
            <td class="count-value">{{resultForm.basePayAfterTax}}</td>
          </tr>
          <tr>
            <td>{{ $xinI18n('个人缴纳公积金','home-gerenjiaonagongjijin') }}</td>
            <td class="count-value">{{resultForm.personalHouseFund}}</td>
            <td>{{ $xinI18n('公司缴纳公积金','home-gsjngjj') }}</td>
            <td class="count-value">{{resultForm.companyHouseFund}}</td>
          </tr>
          <tr>
            <td>{{ $xinI18n('个人缴纳社保','home-gerenjiaonashebao') }}</td>
            <td class="count-value">{{resultForm.personalInsurance}}</td>
            <td>{{ $xinI18n('公司缴纳社保','home-gongsijiaonashebao') }}</td>
            <td class="count-value">{{resultForm.companyInsurance}}</td>
          </tr>
          <tr>
            <td>{{ $xinI18n('年累计缴纳个税','home-nljjngs') }}</td>
            <td class="count-value">{{resultForm.personalTax}}</td>
            <td>{{ $xinI18n('个人专项扣税总额','home-grzxksze') }}</td>
            <td class="count-value">{{resultForm.personalTaxExemption}}</td>
          </tr>
          </tbody>
        </table>
        <p class="tax-before-tax">
          {{$xinI18n('因个税改革施行累计预扣法计税，系统为您计算平均值，当您税前月收入为{#1}时，您的税后年收入总计为{#2}，月平均税后收入达到期望值{#3}','home-ygsggsxljykfjsxtwnjspjzdn',[resultForm.basePayBeforeTax, resultForm.basePayAfterTax * 12, resultForm.basePayAfterTax])}}
        </p>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {CityTreeItem} from '@/module/home/entities/city-tree-item';
  import {
    ChildReduceDeductionOption,
    ChildrenEducationDeductionOption,
    ContinuingEducationDeductionOption,
    HousingLoanDeductionOption,
    HousingRentDeductionOption,
    SupportElderlyDeductionOption,
    SupportElderlyDeductionTypeOption
  } from './const';
  import {HomeApi} from '@/module/home/service/home-api.service';
  import {XinAlert, XinMessage} from '@xin/xin-ui';
  import {Validators} from '@xin/xin-ui/src/components/validators/validators';
  import { vNumRange7, vNumRangeCustomize } from "assets/js/verify-config";
  import {XrxsCommonUtils} from '@xin/xin-core';

  @Component({
    name: 'employee-cost',
    components: {
      XinAlert
    }
  })
  export default class EmployeeCost extends Vue {
    @Prop({required: true}) public cityTree!: CityTreeItem[];
    @Prop({required: true}) public isBeforeTax!: boolean;
    public socialInsuranceOption = [
      {value: 0, label: window.$xinI18n('最低标准','home-zuidibiaozhun')},
      {value: 1, label: window.$xinI18n('按照工资','home-anzhaogongzi')},
      {value: 2, label: window.$xinI18n('自定义','Common-zidingyi')}
    ];
    public insuranceBaseMax = 0;
    public insuranceBaseMin = 0;
    public houseFundMin = 0;
    public houseFundMax = 0;
    public houseFundCompanyPercentMin = 0;
    public houseFundCompanyPercentMax = 0;
    public childrenEducationDeductionOption = ChildrenEducationDeductionOption;
    public continuingEducationDeductionOption = ContinuingEducationDeductionOption;
    public supportElderlyDeductionType = 0;
    public supportElderlyDeductionTypeOption = SupportElderlyDeductionTypeOption;
    public supportElderlyDeductionOption = SupportElderlyDeductionOption;
    public housingLoanDeductionOption = HousingLoanDeductionOption;
    public housingRentDeductionOption = HousingRentDeductionOption;
    public childReduceDeductionOption = ChildReduceDeductionOption;
    public flag = true;
    public employeeCostForm = {
      submit: 1,
      areaId: 510,
      areaArr: [2, 510],
      basePay: null as null | number,
      realPay: null as null | number,
      isSocialInsurance: 1,
      socialInsuranceType: 0,
      socialInsuranceBaseValue: 0 as string | number,
      isHouseFund: 1,
      houseFundType: 0,
      houseFundBaseValue: 0 as string | number,
      houseFundEmployeePercent: 12,
      houseFundCompanyPercent: 12,
      needSeriousMedical: 1,
      before: 1,
      // 专项扣除参数
      isSpecialDeductions: 1,
      childrenEducationDeduction: '',
      continuingEducationDeduction: '',
      supportElderlyDeduction: '',
      housingLoanDeduction: '',
      housingRentDeduction: '',
      childReduceDeduction: '',
      privatePensionDeduction: null as null | number,
    };
    public resultForm: any = {};
    public showResult = false;
    public requiredNumberValidators = [
      {required: true, message: window.$xinI18n('不能为空','Common-bunengweikong'), trigger: 'blur'},
      {
        validator: (rule: any, value: any, cb: any) => {
          Validators.number(rule, value, cb, {message: window.$xinI18n('必须为数字','home-bixuweishuzi')});
        },
        trigger: 'blur'
      }
    ];

    get rules(): any {
      return {
        basePay: this.requiredNumberValidators,
        realPay: this.requiredNumberValidators,
        privatePensionDeduction: this.requiredNumberValidators,
        socialInsuranceBaseValue: this.employeeCostForm.socialInsuranceType == 2 ? this.requiredNumberValidators : [],
        houseFundBaseValue: this.employeeCostForm.houseFundType == 2 ? this.requiredNumberValidators : [],
        houseFundCompanyPercent: this.requiredNumberValidators
      };
    }

    //基本工资字段验证规则
    salaryFieldValidate: any = vNumRange7({ required: true, trigger: 'blur' }).validates;
    pensionFieldValidate: any = vNumRangeCustomize({ required: false,min: 0, max: 12000, trigger: 'blur' }).validates;

    public $refs!: {
      employeeCostForm: any
    };

    mounted() {
      this.calculatorInitParams();
    }

    private calculatorInitParams() {
      HomeApi.getCalculatorInitParams(this.employeeCostForm.areaId).then(result => {
        if (result.status) {
          this.employeeCostForm.socialInsuranceType = 0;
          this.employeeCostForm.houseFundType = 0;
          this.employeeCostForm.basePay = null;
          this.employeeCostForm.socialInsuranceBaseValue = result.data.insuranceBaseMin;
          this.employeeCostForm.houseFundBaseValue = result.data.houseFundMin;
          this.employeeCostForm.houseFundCompanyPercent = result.data.houseFundCompanyPercent;
          this.insuranceBaseMin = result.data.insuranceBaseMin;
          this.insuranceBaseMax = result.data.insuranceBaseMax;
          this.houseFundMax = result.data.houseFundMax;
          this.houseFundMin = result.data.houseFundMin;
          this.houseFundCompanyPercentMax = result.data.houseFundCompanyPercentMax;
          this.houseFundCompanyPercentMin = result.data.houseFundCompanyPercentMin;
        } else {
          XinMessage.error(window.$xinI18n('报错啦~~~','home-baocuola'));
        }
      });
    }

    public handleChange() {
      this.employeeCostForm.areaId = this.employeeCostForm.areaArr[this.employeeCostForm.areaArr.length - 1];
      this.calculatorInitParams();
    }

    public changeSocialInsuranceBaseValue(val: number) {
      if (this.employeeCostForm.socialInsuranceType == 1) {
        this.employeeCostForm.socialInsuranceBaseValue = val;
      }
      if (this.employeeCostForm.houseFundType == 1) {
        this.employeeCostForm.houseFundBaseValue = val;
      }
    }

    public changeInsuranceValue(val: number) {
      if (val == 0) {
        this.employeeCostForm.socialInsuranceBaseValue = this.insuranceBaseMin;
      } else if (val == 1) {
        if(!this.isBeforeTax) {
          this.employeeCostForm.socialInsuranceBaseValue = this.employeeCostForm.basePay as number;
        }else {
          this.employeeCostForm.socialInsuranceBaseValue = '';
        }

      } else if (val == 2) {
        this.employeeCostForm.socialInsuranceBaseValue = '';
      }

      if(val != 2) {
        this.$refs.employeeCostForm.clearValidate();
      }
    }

    public changeHouseFundBaseValue(val: number) {
      if (val == 0) {
        this.employeeCostForm.houseFundBaseValue = this.houseFundMin;
      } else if (val == 1) {
        if(!this.isBeforeTax) {
          this.employeeCostForm.houseFundBaseValue = this.employeeCostForm.basePay as number;
        }else {
          this.employeeCostForm.houseFundBaseValue = '';
        }
      } else if (val == 2) {
        this.employeeCostForm.houseFundBaseValue = '';
      }

      if(val != 2) {
        this.$refs.employeeCostForm.clearValidate();
      }
    }

    public switchOnly(type: string) {
      if (!this.flag) {
        this.flag = true;
        return;
      }

      switch (type) {
        case 'housingRent':
          this.employeeCostForm.housingRentDeduction = '';
          this.flag = false;
          break;
        case 'housingLoan':
          this.employeeCostForm.housingLoanDeduction = '';
          this.flag = false;
          break;
        case 'childDeduction':
          break;
        default:
          return;
      }
    }

    public startToCalculator() {
      let postData = XrxsCommonUtils.deepClone(this.employeeCostForm);
      delete postData.areaArr;
      postData.submit = 1;
      if (this.isBeforeTax) {
        delete postData.basePay;
        postData.socialInsuranceBase = postData.socialInsuranceType;
        delete postData.socialInsuranceType;
        postData.houseFundBase = postData.houseFundType;
        delete postData.houseFundType;
        delete postData.houseFundEmployeePercent;
        delete postData.needSeriousMedical;
        postData.houseFundPercent = this.employeeCostForm.houseFundCompanyPercent;
      } else {
        delete postData.realPay;
        postData.houseFundEmployeePercent = this.employeeCostForm.areaId == 549 ? this.employeeCostForm.houseFundEmployeePercent : this.employeeCostForm.houseFundCompanyPercent;
      }
      this.$refs.employeeCostForm.validate((valid: boolean) => {
        if (valid) {
          HomeApi.employeeCostCount(this.isBeforeTax, postData).then(res => {
            if (res.status) {
              XinMessage.success(res.message);
              this.showResult = true;
              if (this.isBeforeTax) {
                this.resultForm.basePayBeforeTaxWithYear = res.data.basePayBeforeTaxWithYear;
                this.resultForm.basePayAfterTaxWithYear = res.data.basePayAfterTaxWithYear;
                this.resultForm.basePayBeforeTax = res.data.basePayBeforeTax;
                this.resultForm.basePayAfterTax = res.data.basePayAfterTax;
                this.resultForm.personalHouseFund = res.data.personalHouseFund;
                this.resultForm.companyHouseFund = res.data.companyHouseFund;
                this.resultForm.personalInsurance = res.data.personalInsurance;
                this.resultForm.companyInsurance = res.data.companyInsurance;
                this.resultForm.companyTotalCost = res.data.companyTotalCost;
                this.resultForm.personalTax = res.data.personalTax;
                this.resultForm.personalTaxExemption = res.data.personalTaxExemption;
              } else {
                this.resultForm.basePayBeforeTax = res.data.basePayBeforeTax;
                this.resultForm.basePayAfterTax = res.data.basePayAfterTax;
                this.resultForm.personalHouseFund = res.data.personalHouseFund;
                this.resultForm.companyHouseFund = res.data.companyHouseFund;
                this.resultForm.personalInsurance = res.data.personalInsurance;
                this.resultForm.companyInsurance = res.data.companyInsurance;
                this.resultForm.companyTotalCost = res.data.companyTotalCost;
                this.resultForm.personalTax = res.data.personalTax;
                this.resultForm.personalTaxExemption = res.data.personalTaxExemption;
                this.resultForm.basePayAfterTaxWithMonth = res.data.basePayAfterTaxWithMonth;
                this.resultForm.withholdableAdvancePayment = res.data.withholdableAdvancePayment;
                this.resultForm.accumulatedAnnualTaxes = res.data.accumulatedAnnualTaxes;
                this.resultForm.accumulatedBasePayAfterTax = res.data.accumulatedBasePayAfterTax;
              }

              this.$forceUpdate();
            }
          });
        }
      });
    }
  }
</script>

<style lang="scss" scoped>
  @import "employee-cost";
</style>
